<template>
    <div class="root">
        <div class="row" v-for="(row, index) in value" :key="index">
            <div class="inputColumn">
                <v-text-field v-model="row.shopId" label="Shop ID" type="number" />
            </div>
            <div class="inputColumn">
                <v-select label="Color" v-model="row.color" :items="shopColors" />
            </div>
            <div class="actionColumn">
                <v-icon small @click="remove(index)">delete</v-icon>
            </div>
        </div>
        <div>
            <v-btn @click="sort">Sort</v-btn>
            <v-btn @click="add">Add</v-btn>
        </div>
    </div>
</template>

<script>
import shopColors from '../../../../constants/order-history-shop-colors'

export default {
    props: {
        value: {
            type: Array
        }
    },
    data() {
        return {
            shopColors
        }
    },
    methods: {
        add() {
            const { value = [] } = this
            this.$emit('input', [
                ...value,
                {
                    color: this.shopColors[0].id,
                    shopId: ''
                }
            ])
        },
        remove(index) {
            let { value = [] } = this
            value = value.slice()
            value.splice(index, 1)

            this.$emit('input', value)
        },
        sort() {
            this.$emit(
                'input',
                [...this.value].sort((a, b) => {
                    return a.shopId.localeCompare(b.shopId)
                })
            )
        }
    }
}
</script>

<style scoped>
.root {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
}

.row {
    display: flex;
    align-items: flex-start;
    flex-flow: row nowrap;
    margin: 0 -5px;
}

.row > * {
    padding: 0 5px;
}

.inputColumn {
    flex: 1;
}

.actionColumn {
    padding-top: 16px;
}
</style>
